<script lang="ts">
    import Icon from "../Icon/Icon.svelte";


    export let btnClass: string = "gray"; 
    export let onClick: () => void;
    export let icon: string = "fa fa-circle";
    export let disabled: boolean = false;
    export let title: string = "";
</script>

<button class="btn {btnClass}" on:click={onClick} {disabled} {title}>
    <Icon name={icon} />
</button>

<style>
    .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        border-radius: 9999px;
        color: white;
        box-shadow: 0 6px 14px rgba(0, 0, 0, 0.25);
        transition: all 0.15s ease;
        cursor: pointer;
        border: none;
    }

    .btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .btn.gray {
        background: #4b5563;
    }
    .btn.gray:hover {
        background: #374151;
    }
    .btn.green {
        background: #16a34a;
    }
    .btn.green:hover {
        background: #15803d;
    }
    .btn.red {
        background: #dc2626;
    }
    .btn.red:hover {
        background: #b91c1c;
    }
    .btn.yellow {
        background: #eab308;
    }
    .btn.yellow:hover {
        background: #ca8a04;
    }
    .btn.blue {
        background: #2563eb;
    }
    .btn.blue:hover {
        background: #1d4ed8;
    }
</style>
